module.exports = __webpack_public_path__ + "static/cannelle-bfd6c4560f2ceb2998c6e47343df1656.jpg";